import Ajax from '../../assets/js/Ajax'

export default {
    namespaced: true,
    state: () => ({
        sukikamo_list: null,
    }),
    mutations: {
        setSukikamoList(state, data) {
            state.sukikamo_list = data;
        }
    },
    actions: {
        async reloadSukikamoList({commit}) {
            const sukikamo_list = await Ajax.getAllSukikamo();
            commit('setSukikamoList', sukikamo_list);
        }
    },
    getters: {

    },
}
